module.exports = __webpack_public_path__ + "img/twitter-circle.fd9de7e3.svg";